/* eslint-disable new-cap */
import {
  NodeViewWrapper,
  ReactNodeViewRenderer,
  type NodeViewProps,
} from '@tiptap/react';
import TiptapImage from '@tiptap/extension-image';
import { Button, TextInput } from '@tremor/react';
import { Trash2 } from 'lucide-react';
import { msg } from '@lingui/macro';
import { useLingui } from '@lingui/react';

type ImageComponentProperties = NodeViewProps & {
  readonly node: {
    attrs: {
      'src': string;
      'alt'?: string;
      'data-image'?: string;
      'sgid'?: string;
    };
  };
};

function ImageComponent(properties: ImageComponentProperties) {
  const { node, updateAttributes, deleteNode } = properties;
  const { alt, ...imgAttributes } = node.attrs;
  const { _ } = useLingui();

  return (
    <NodeViewWrapper className='w-full relative'>
      <Button
        color='red'
        icon={Trash2}
        className='absolute top-2 right-2 cursor-pointer border-0 p-1 z-1'
        onClick={deleteNode}
      />
      <img {...imgAttributes} alt={alt ?? ''} />
      <TextInput
        className='mt-1'
        placeholder={_(msg`Alt text (describe this image for screen readers)`)}
        value={alt ?? ''}
        onChange={(event) => {
          updateAttributes({ alt: event.target.value });
        }}
      />
    </NodeViewWrapper>
  );
}

export const Image = TiptapImage.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      'data-image': {
        default: null,
      },
      'sgid': {
        default: null,
      },
    };
  },

  addNodeView() {
    return ReactNodeViewRenderer(ImageComponent);
  },
});
